import React from "react";
import { PIPELINE, SOFT_QUOTE, DEAD, CLOSED, SOLD } from "constants/status";

export const formatLabel = statuses => {
  const status = statuses[0];
  switch (status) {
    case PIPELINE:
      return { upper: "PIPELINE DEALS", lower: "Pipeline Deals" };
    case DEAD:
      return { upper: "DEAD DEALS", lower: "Dead Deals" };
    case CLOSED:
      return { upper: "CLOSED DEALS", lower: "Closed Deals" };
    case SOLD:
      return { upper: "SOLD DEALS", lower: "Sold Deals" };
  }
};

const DealLabel = ({ status }) => (
  <div className="tableOuterHeader sub-title-component">
    {formatLabel(status).lower}
  </div>);

export default DealLabel;
